import consumerApi from "api/services/consumer-api";
import { ScheduleStatuses } from "custom-types/Dispensary";
import { WeeklySchedule } from "custom-types/DispensarySchedules";
import logError from "utils/logError";

export const getCurrentStatuses = async (
  dispensarySlug: string,
): Promise<{
  currentStatuses: ScheduleStatuses;
  schedules: WeeklySchedule;
} | null> => {
  try {
    const {
      data: { currentStatuses, schedules },
    } = await consumerApi.get(`api/dispensaries/v1/${dispensarySlug}`);

    return { currentStatuses, schedules };
  } catch (e) {
    logError(e.message, {
      functionName: "getCurrentStatuses",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return null;
  }
};
